import privateAxios from "../utils/axiosPrivate";
import {
  accountImageDataURL,
  accountSoftwareURL,
  getaccountSoftwareEditURL,
  getAccSoftwareStatusURL
} from "../utils/constants/apiEndPoints";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import { commonErrMsg } from "../locales/en";

// Initial state
const initialState = {
  loading: false,
  loadingEditThunk: false,
  loadingImageThunk: false,
  loadingAccountUserData: false
};

const accountingSoftwareSlice = createSlice({
  name: "accountingSoftware",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(accountsoftwareImageThunk.pending, (state) => {
        state.loadingImageThunk = true;
      })
      .addCase(accountsoftwareImageThunk.fulfilled, (state) => {
        state.loadingImageThunk = false;
      })
      .addCase(accountsoftwareImageThunk.rejected, (state) => {
        state.loadingImageThunk = false;
      })
      .addCase(accountsoftwareEditThunk.pending, (state) => {
        state.loadingEditThunk = true;
      })
      .addCase(accountsoftwareEditThunk.fulfilled, (state) => {
        state.loadingEditThunk = false;
      })
      .addCase(accountsoftwareEditThunk.rejected, (state, action) => {
        state.loadingEditThunk = false;
        action.payload &&
          showToast(action.payload.message, showToastType.error);
      })
      .addCase(accountsoftwareListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(accountsoftwareListThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(accountsoftwareListThunk.rejected, (state, action) => {
        state.loading = false;

        const message =
          action.payload?.response?.data?.errors?.[0] ||
          action.payload?.response?.data?.message ||
          action.payload.message ||
          commonErrMsg.item7;

        showToast(message, showToastType.error);
      })
      .addCase(loadAccountUserDataThunk.pending, (state) => {
        state.loadingAccountUserData = true;
      })
      .addCase(loadAccountUserDataThunk.fulfilled, (state) => {
        state.loadingAccountUserData = false;
      })
      .addCase(loadAccountUserDataThunk.rejected, (state, action) => {
        state.loadingAccountUserData = false;
        let message;
        if (action.payload && action.payload.status === 500) {
          message = action.payload.data.errors;
        } else {
          message = action.payload.message;
        }

        showToast(message, showToastType.error);
      });
  }
});

// Thunk: get Accounting Software list
export const accountsoftwareListThunk = createAsyncThunk(
  "accountingSoftware/getCustomerList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(accountSoftwareURL, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Thunk: Accounting Software Edit
export const accountsoftwareEditThunk = createAsyncThunk(
  "accountingSoftware/accountsoftwareEditThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getaccountSoftwareEditURL(payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Thunk: get image
export const accountsoftwareImageThunk = createAsyncThunk(
  "accountingSoftware/getImageList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(accountImageDataURL(payload), {
        responseType: "blob"
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// load account user data
export const loadAccountUserDataThunk = createAsyncThunk(
  "accountingSoftware/loadAccountUserData",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getAccSoftwareStatusURL(id), {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default accountingSoftwareSlice.reducer;
